import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconConcise: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="concise, text-shorten, squeeze"><path d="M3.75 10.25H20.25M20.25 13.75H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M9 20.25L12 17.25L15 20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M15 3.75L12 6.75L9 3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconConcise;
